import axios from '../../../shared/services/axios.interceptor'
import type { MeApiResponse } from '../domain/models/me-api'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000'

export class UserApiService {
  private readonly baseUrl: string

  constructor(baseUrl: string = API_BASE_URL) {
    this.baseUrl = baseUrl
  }

  public async getMe(): Promise<MeApiResponse> {
    const response = await axios.get<MeApiResponse>(`${this.baseUrl}/api/v1/me`)
    return response.data
  }
}

// Singleton instance
export const userApiService = new UserApiService()
